<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1">{{ tajukKad }}</p>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <table class="tableBordered">
            <tbody>
              <tr>
                <th>Bil.</th>
                <th>Syarikat Minyak</th>
                <th>Pecahan (%)</th>
              </tr>
              <tr v-for="(item, key) in syarikatminyakArray" :key="key">
                <td>{{ key + 1 }}</td>
                <td>{{ item.syarikatminyakName }}</td>
                <td>{{ item.syarikatminyakPercentage }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'syarikat-minyak',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false
    }
  },
  methods: {
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    }
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    syarikatminyakArray: {
      type: Array
    }
  },
  mounted() {
    console.log('syarikatminyakArray', this.syarikatminyakArray)
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mypetrol/components/SyarikatMinyak.vue